var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"stop-covid"}},[_c('section',{staticClass:"jumbo-wrapper"},[_c('b-container',{staticClass:"mt-3 greeting-block"},[_c('b-row',[_c('b-col',{staticClass:"platform-column"},[_c('b-img',{staticClass:"platform-logo mx-auto",attrs:{"src":"./dist/medsafe.png","fluid":""}})],1)],1)],1)],1),_vm._v(" "),_c('b-navbar',{attrs:{"id":"footer"}},[_c('b-container',[_c('p',{staticClass:"ml-auto"},[_vm._v("«‎ООО МедСейф»™ © 2021")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e3751b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/StopCovid.vue
// module id = 686
// module chunks = 0